<!-- Terms And Conditions Modal -->
<div *ngIf="termsAndConditionModal" class="overlay">
    <div class="popup bg-body_Bg_Color overflow-auto xs:h-5/6 md:h-4/5 xs:w-5/6 xl:w-3/5">
        <button (click)="close()" type="button" class="close   text-2xl" data-dismiss="modal"
            aria-label="Close" style="position: absolute;right: 12px;top: 0px;">
            <span aria-hidden="true">&times;</span>
        </button>
        <div class="overflow-auto text-left h-[66vh] xs:text-xs sm:text-sm md:text-base mt-5"[innerHTML]="trustedTermsAndCondition">
        </div>
        <app-button (buttonClick)="close()" [class]="'close-modal-btn  xs:text-xs sm:text-sm'" [innerText]="'Close'"></app-button>

    </div>
</div>


<!-- Privacy Policy Modal -->
<div *ngIf="privacyPolicyModal" class="overlay">
    <div class="popup bg-body_Bg_Color overflow-auto  xs:h-5/6 md:h-4/5 xs:w-5/6 xl:w-3/5">
        <button (click)="close()" type="button" class="close text-2xl" data-dismiss="modal"
            aria-label="Close" style="position: absolute;right: 12px;top: 0px;">
            <span aria-hidden="true">&times;</span>
        </button>
        <div class="overflow-auto text-left h-[66vh] xs:text-xs sm:text-sm md:text-base mt-5"[innerHTML]="trustedPrivacyPolicy">
        </div>
        <app-button (buttonClick)="close()" [class]="'close-modal-btn  xs:text-xs sm:text-sm'" [innerText]="'Close'"></app-button>

    </div>
</div>